<template>
  <ul class="flex items-baseline flex-wrap leading-5 md:leading-[18px]">
    <template v-for="(child, index) in children" :key="index">
      <li class="flex items-center">
        <component :is="child" v-if="child" />
        <span v-if="index < children.length - 1" class="mx-1 inline-flex items-center leading-none text-[1em] top-[1px] relative" aria-hidden="true">•</span>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import type { VNode } from 'vue'
import { computed } from 'vue'

const slots = defineSlots<{
  default(): VNode[]
}>()

const children = computed(() => {
  const nodes = slots.default?.()
  if (!nodes) {
    return []
  }

  return nodes.flatMap((node: VNode) => {
    if (Array.isArray(node.children)) {
      return node.children.filter((child): child is VNode => child !== null && typeof child === 'object')
    }
    return node
  })
})
</script>

